// extracted by mini-css-extract-plugin
export default {"red":"Jr7pA6GGohkPJ4r6QO5G","gray":"BAMdehufq8RPmky_ITHG","condition":"LtEfc3ISJzrmXDNx3ete"};